/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators

  The value being validated is the v-model of <cf-phone-number-input>, which is
  canonical E.164 ("+14155555510"). Validation uses libphonenumber-js's
  country-specific metadata — the same source the input UI uses to mask and
  format — so the rule and the mask never disagree.
*/

import { isPossiblePhoneNumber } from 'libphonenumber-js';



/*
  We use `isPossiblePhoneNumber` (length-by-country check) rather than
  `isValidPhoneNumber` (strict NANP / national numbering plan rules) so
  legitimate-but-unusual numbers and common test patterns aren't blocked
  before the BE has a chance to reject genuinely-bad input. The BE is the
  authoritative validator — this rule is just a fast UX guard against
  obviously-wrong lengths.
*/
const validatePhoneNumber = (value) => {
  if (value == null || value === '') return true;

  if (isPossiblePhoneNumber(String(value))) return true;

  return 'Must enter a valid phone number.';
};



export default validatePhoneNumber;
